<h1 mat-dialog-title>{{ 'DIALOGS.WARNING' | translate }}</h1>
<mat-dialog-content>
  {{ 'DIALOGS.OFFLINE_ORDER_ONLINE' | translate }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="OFFLINE_ONLINE_DIALOG_RESULTS.KEEP_OFFLINE">
    {{ 'DIALOGS.KEEP_OFFLINE' | translate }}
  </button>
  <button mat-button [mat-dialog-close]="OFFLINE_ONLINE_DIALOG_RESULTS.STORE_ONLINE">
    {{ 'DIALOGS.YES' | translate }}
  </button>
</mat-dialog-actions>
